/* mesoestetic-product-catalogue-en-new - Swiper Init */

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.elementor-image-carousel-wrapper').forEach(function(wrapper) {
    var container = wrapper.querySelector('.elementor-image-carousel');
    if (!container) return;
    var widget = wrapper.closest('[data-settings]');
    var settings = {};
    try { settings = JSON.parse(widget ? widget.getAttribute('data-settings') : '{}'); } catch(e) {}
    new Swiper(wrapper, {
      loop: settings.infinite === 'yes',
      autoplay: settings.autoplay === 'yes' ? {
        delay: settings.autoplay_speed || 5000,
        pauseOnMouseEnter: settings.pause_on_hover === 'yes',
      } : false,
      speed: settings.speed || 500,
      slidesPerView: 1,
      effect: settings.effect || 'slide',
    });
  });
});